module.exports = __webpack_public_path__ + "media/share_images/notes-148e4a5b.svg";